import { render, staticRenderFns } from "./ScreenLimitReachedBanner.vue?vue&type=template&id=0096ce76&scoped=true&"
import script from "./ScreenLimitReachedBanner.vue?vue&type=script&lang=js&"
export * from "./ScreenLimitReachedBanner.vue?vue&type=script&lang=js&"
import style0 from "./ScreenLimitReachedBanner.vue?vue&type=style&index=0&id=0096ce76&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0096ce76",
  null
  
)

export default component.exports